const layout = {
  lg: [
    {
      w: 8,
      h: 2,
      x: 0,
      y: 0,
      i: "graph1"
    },
    {
      w: 4,
      h: 2,
      x: 8,
      y: 0,
      i: "graph2"
    },
    {
      w: 5,
      h: 2,
      x: 0,
      y: 0,
      i: "graph3"
    },
    {
      w: 3,
      h: 2,
      x: 5,
      y: 0,
      i: "graph4"
    },
    {
      w: 4,
      h: 2,
      x: 9,
      y: 2,
      i: "graph5"
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: "graph6"
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 2,
      i: "graph7"
    }
  ],
  md: [
    {
      w: 6,
      h: 2,
      x: 0,
      y: 0,
      i: "graph1"
    },
    {
      w: 4,
      h: 2,
      x: 6,
      y: 0,
      i: "graph2"
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 0,
      i: "graph3"
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 0,
      i: "graph4"
    },
    {
      w: 4,
      h: 2,
      x: 6,
      y: 2,
      i: "graph5"
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: "graph6"
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 2,
      i: "graph7"
    }
  ],
  sm: [
    {
      w: 6,
      h: 2,
      x: 0,
      y: 0,
      i: "graph1"
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 0,
      i: "graph2"
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 0,
      i: "graph3"
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 0,
      i: "graph4"
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: "graph5"
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 2,
      i: "graph6"
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: "graph7"
    }
  ],
  xs: [
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: "graph1"
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: "graph2"
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: "graph3"
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: "graph4"
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: "graph5"
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: "graph6"
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: "graph7"
    }
  ]
};

export default layout;
